/* eslint-disable react-hooks/exhaustive-deps */
// @ts-nocheck
import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Grid,
  TextField,
  Typography,
  Input,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Checkbox,
  TableBody,
  InputAdornment,
  IconButton,
} from "@mui/material";
import PhoneInput from "react-phone-input-2";
import * as Yup from "yup";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import MainContainer from "../../layout/MainContainer";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import CancelIcon from "@mui/icons-material/Cancel";
import { UploadMedia } from "../../utils/mediaUpload";
import { Loader, showError, showToast } from "../../constants";
import { useFormik } from "formik";
import { isString } from "../../utils/validations";
// import {
//   useAddSubadminMutation,
//   useLazyGetSubadminByIdQuery,
//   useUpdateSubadminMutation,
// } from "../../services/addsubadmin";
import { useAddSubadminMutation, useLazyGetSubadminByIdQuery,
  useUpdateSubadminMutation, } from "../../services/subadmin";
interface DataType {
  _id?: string;
  label: string;
  isEdit: boolean;
  isView: boolean;
  isDelete?: boolean;
  disabled?: boolean;
  name: string;
}

const AddSubAdmin = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [phoneCode, setPhoneCode] = useState("+91");
  // const [showPassword, setShowPassword] = useState(false);
  const [image, setImage] = useState<string>("");
  const [subAdminData, setSubadminData] = useState<any>();
  const [newData, setNewData] = useState<DataType[]>([] as any);
  const [permissions, setPermissions] = useState<DataType[]>([
    {
      _id: "1",
      label: "Dashboard",
      isEdit: false,
      isView: false,
      isDelete: false,
      disabled: false,
      name: "Dashboard"
    },

    {
      _id: "2",
      label: "Allergies",
      isEdit: false,
      isView: false,
      isDelete: false,
      disabled: false,
      name: "Allergies",
    },
    {
      _id: "3",
      label: "Products",
      isEdit: false,
      isView: false,
      isDelete: false,
      disabled: false,
      name: "Products",
    },
    {
      _id: "4",
      label: "Users",
      isEdit: false,
      isView: false,
      isDelete: false,
      disabled: false,
      name: "Users",
    },
    {
      _id: "5",
      label: "Subscriptions",
      isEdit: false,
      isView: false,
      isDelete: false,
      disabled: false,
      name: "Subscriptions",
    },
    {
      _id: "6",
      label: "Community",
      isEdit: false,
      isView: false,
      isDelete: false,
      disabled: false,
      name: "Community",
    },
    {
      _id: "7",
      label: "Sub-Admin",
      isEdit: false,
      isView: false,
      isDelete: false,
      disabled: false,
      name: "Sub-Admin",
    },
    {
      _id: "8",
      label: "Notifications",
      isEdit: false,
      isView: false,
      isDelete: false,
      disabled: false,
      name: "Notifications",
    },
    {
      _id: "9",
      label: "Customer Support",
      isEdit: false,
      isView: false,
      isDelete: false,
      disabled: false,
      name: "Customer support",
    },
    {
      _id: "10",
      label: "CMS",
      isEdit: false,
      isView: false,
      isDelete: false,
      disabled: false,
      name: "CMS",
    },
    
  ]);

  const [getSubAdminMethod, { isLoading }] = useLazyGetSubadminByIdQuery();
  const [addSubAdminMethod] = useAddSubadminMutation();
  const [updateSubAdminMethod] = useUpdateSubadminMutation();
  const onSelectChange = (key: any, type: string) => {
    let idx = permissions.findIndex((obj) => obj.label === key.label);
    if (type === "addEdit") {
        permissions[idx].isEdit = !key.isEdit;
        if (key.isEdit) {
           
            permissions[idx].isView = true;
        }
    } else if (type === "isview") {
        permissions[idx].isView = !key.isView;
        if (!permissions[idx].isView) {
            
            permissions[idx].isEdit = false;
            permissions[idx].isDelete = false;
        }
    } else {
        permissions[idx].isDelete = !key.isDelete;
        if (key.isDelete) {
         
            permissions[idx].isView = true;
        }
    }
    setPermissions([...permissions]);
};


  const handleImageUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target;
    const file = files?.files?.length ? files?.files[0] : "";
    const res = await UploadMedia(file);
    if (res?.statusCode === 200) {
      setImage(res?.data);
    } else {
      showError(res?.message);
    }
  };

  // const handleClickShowPassword = () => {
  //   setShowPassword(!showPassword);
  //   const inputEl: HTMLInputElement | null = document.getElementById(
  //     "password"
  //   ) as HTMLInputElement | null;
  //   if (inputEl) {
  //     setTimeout(() => {
  //       inputEl.setSelectionRange(inputEl.value.length, inputEl.value.length);
  //     }, 0);
  //   }
  // };

  const handleMouseDownPassword = (event: any) => {
    event.preventDefault();
  };

  const handleChangePhone = (phone: any, country: any) => {
    formik.setFieldValue("phone", phone?.replace(country.dialCode, ""));
    setPhoneCode(country?.dialCode);
  };

  const label = { inputProps: { "aria-label": "Switch demo" } };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: subAdminData?.name || "",
      // lastName: subAdminData?.lastName || "",
      email: subAdminData?.email || "",
      phone: subAdminData?.phone || "",
      // password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .required("Email is required")
        .matches(
          /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
          "Enter a valid email address"
        ),
      name: Yup.string()
        .required(" name is required")
        .min(2, "Minimum 2 characters are required")
        .max(80, "Maximum 80 character are allowed"),
      // lastName: Yup.string()

      //   .min(2, "Minimum 2 characters are required")
      //   .max(80, "Maximum 80 character are allowed"),

      phone: Yup.string()
        .required("Phone number is required")
        .min(6, "Phone number must be at least 6 characters")
        .max(16, "Phone number must be at least 16 characters"),
      // password: id
      //   ? Yup.string().notRequired()
      //   : Yup.string()
      //       .required("Password is required!")
      //       .min(6, "Password must be at least 6 characters"),
    }),
    onSubmit: async (values) => {
      formik.setSubmitting(true);
      // if (!image) {
      //   setError(true);
      //   return;
      // }

      // const result = {
      //   subAdminId: {},
      // };

      // permissions?.length > 0 &&
      //   permissions?.forEach((item) => {
      //     const { name, isEdit, isView, isDelete } = item;
      //     result.subAdminId[`${name}Add`] = isEdit || false;
      //     result.subAdminId[`${name}View`] = isView || false;
      //     result.subAdminId[`${name}Delete`] = isDelete || false;
      //   });

      // console.log({ result });

      permissions?.length > 0 &&
      permissions.map((element) => {
        const obj = {
          name: element?.label,
          isEdit: element.isEdit,
          isView: element.isView,
          isDelete: element.isDelete,
        };
        if (obj) {
          newData?.push(obj);
          setNewData([...newData]);
        }
      });

    const hasSelectedPermission = permissions.some(
      (permission) =>
        permission.isEdit || permission.isView || permission.isDelete
    );

    if (!hasSelectedPermission) {
      showError("At least one permission must be selected");
      formik.setSubmitting(false); // Set submitting back to false
      return false; // Stop further execution
    }

      // const subAdminId = result?.subAdminId || {};
      let body = {
        ...{
          email: formik.values.email,
          name: formik.values.name,
          // lastName: formik.values.lastName,
          countryCode: (phoneCode.includes("+") ? "" : "+") + phoneCode,
          phone: formik.values.phone,
          image: image,
          // password: formik.values.password,
          permissions: newData.filter((element) => {
            return (
              element.isView === true ||
              element.isEdit === true ||
              element.isDelete === true
            );
          }),
        },
        // ...subAdminId,
      };
      console.log(body, "body");

      const update_body = {
        ...{
          email: formik.values.email,
          name: formik.values.name,
          // lastName: formik.values.lastName,
          countryCode: (phoneCode.includes("+") ? "" : "+") + phoneCode,
          phone: formik.values.phone,
          image: image,
        },
        // ...subAdminId,
      };

      if (id) {
        try {
          const response = await updateSubAdminMethod({
            sub_id: id,
            body: body,
          }).unwrap();
          if (response?.statusCode === 200) {
            showToast("Subadmin Updated Successfully");
            navigate("/manage-sub-admin");
          } else {
            showError(response?.message || "");
          }
        } catch (error: any) {
          showError(error?.data?.message || "");
          console.log(error);
        }
      } else {
        try {
          const response = await addSubAdminMethod(body).unwrap();
          if (response?.statusCode === 200) {
            showToast("Subadmin Created Successfully");
            navigate("/manage-sub-admin");
          }
        } catch (error: any) {
          showError(error?.data?.message || "");
          console.log(error);
        }
      }
    },
  });

  const getSubAdminDetail = async () => {
    try {
      const res = await getSubAdminMethod({ sub_id: id }).unwrap();
      if (res?.statusCode === 200) {
        setSubadminData(res?.data);
        setPhoneCode(res?.data?.countryCode || "+966");
        setImage(res?.data?.image || "");
        // const labels = {
        //   trainer: "Manage Trainers",
        //   category: "Manage Categories",
        //   cms: "Manage CMS",
        //   trainingMaterial: "Manage Training Material",
        //   agent: "Manage Agents",
        // };

        // const data = Object.keys(labels).map((name) => {
        //   return {
        //     id: res?.data?.id,
        //     label: labels[name],
        //     isEdit: res?.data?.subAdminId[`${name}Add`] || false,
        //     isView: res?.data?.subAdminId[`${name}View`] || false,
        //     isDelete: res?.data?.subAdminId[`${name}Delete`] || false,
        //     disabled: false,
        //     name: name,
        //   };
        // });
        const modifiedArr2 = permissions.map((item) => {
          const foundItem = res?.data?.permissions?.find(
            (i: any) => i?.name === item.name
          );
          if (foundItem) {
            return {
              ...item,
              isView: foundItem.isView,
              isEdit: foundItem.isEdit,
              isDelete: foundItem.isDelete,
            };
          }
          return item;
        });
        setPermissions(modifiedArr2);
      
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      console.log(error);
    }
  };

  useEffect(() => {
    if (id) {
      getSubAdminDetail();
    }
  }, []);

  return (
    <>
      <MainContainer>
        <Loader isLoad={isLoading} />
        <div className="main_loyout">
          <div className="dashboard">
            {id ? <h1>Edit Sub-Admin</h1> : <h1>Add Sub-Admin</h1>}
            <Button
              className="btn btn_primary"
              onClick={() => {
                navigate("/manage-sub-admin");
              }}
            >
              Back
            </Button>
          </div>
          <Card className="cards">
            <form onSubmit={formik.handleSubmit}>
              <CardContent sx={{ p: 1 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography className="custom_label">Image</Typography>
                    {image ? (
                      <div className="upload_image_preview">
                        <CardMedia component="img" image={image} alt="photo" />
                        <CancelIcon
                          sx={{ cursor: "pointer" }}
                          onClick={() => {
                            setImage("");
                          }}
                        />
                      </div>
                    ) : (
                      <Box className="upload_image">
                        <label htmlFor="icon-button-file">
                          <Input
                            sx={{ display: "none" }}
                            id="icon-button-file"
                            type="file"
                            inputProps={{
                              accept: "image/png,image/jpeg",
                            }}
                            onChange={handleImageUpload}
                          />
                          <Button component="span" className="upload_image_btn">
                            <img
                              src={
                                image
                                  ? image
                                  : "/static/images/user_placeholder.png"
                              }
                              alt=""
                            />
                            <CameraAltIcon />
                          </Button>
                        </label>
                      </Box>
                    )}
                  </Grid>
                  <Grid item xs={4}>
                    <Typography className="custom_label">Full Name</Typography>
                    <TextField
                      className="text_field"
                      hiddenLabel
                      type={"text"}
                      name="name"
                      variant="outlined"
                      fullWidth
                      placeholder="Full Name"
                      id="name"
                      onBlur={formik.handleBlur}
                      value={formik.values.name}
                      onChange={(val) => {
                        if (
                          val.target.value === " " ||
                          val.target.value === "."
                        ) {
                        } else if (isString(val.target.value)) {
                          formik.handleChange(val);
                        }
                      }}
                      helperText={
                        formik.touched.name && formik.errors.name
                      }
                    />
                  </Grid>
                  {/* <Grid item xs={4}>
                    <Typography className="custom_label">Last Name</Typography>
                    <TextField
                      className="text_field"
                      hiddenLabel
                      type={"text"}
                      name="lastName"
                      variant="outlined"
                      fullWidth
                      placeholder="Last Name"
                      id="lastName"
                      onBlur={formik.handleBlur}
                      value={formik.values.lastName}
                      onChange={(val) => {
                        if (
                          val.target.value === " " ||
                          val.target.value === "."
                        ) {
                        } else if (isString(val.target.value)) {
                          formik.handleChange(val);
                        }
                      }}
                      helperText={
                        formik.touched.lastName && formik.errors.lastName
                      }
                    />
                  </Grid> */}
                  <Grid item xs={4}>
                    <Typography className="custom_label">Email</Typography>
                    <TextField
                      className="text_field"
                      hiddenLabel
                      type={"email"}
                      name="email"
                      variant="outlined"
                      fullWidth
                      placeholder="Email"
                      id="email"
                      onBlur={formik.handleBlur}
                      value={formik.values.email}
                      onChange={formik.handleChange}
                      helperText={formik.touched.email && formik.errors.email}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <Typography className="custom_label">
                      Phone Number
                    </Typography>
                    <PhoneInput
                      enableSearch={true}
                      value={phoneCode + formik.values.phone}
                      country={"us"}
                      inputClass="phoneInput"
                      placeholder="Phone Number"
                      inputStyle={{ width: "100%" }}
                      onChange={(phone, country) =>
                        handleChangePhone(phone, country)
                      }
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.phone && formik.errors.phone ? (
                      <h6 className="err_msg">
                        {formik.touched.phone && formik.errors.phone}
                      </h6>
                    ) : (
                      ""
                    )}
                  </Grid>
                  {/* {id ? null : (
                    <Grid item xs={4}>
                      <Typography className="custom_label">Password</Typography>
                      <TextField
                        className="text_field"
                        hiddenLabel
                        placeholder="Password"
                        fullWidth
                        name="password"
                        id="password"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.password}
                        helperText={
                          formik.touched.password && formik.errors.password
                        }
                        type={showPassword ? "text" : "password"}
                        variant="outlined"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment className="eye_btn" position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                              >
                                {showPassword ? (
                                  <Visibility />
                                ) : (
                                  <VisibilityOff />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                  )} */}
                  <Grid item xs={12}>
                    <TableContainer className="table_container">
                      <Box className="heading"></Box>
                      <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell>Module</TableCell>
                            <TableCell>Add/Edit</TableCell>
                            <TableCell>View</TableCell>
                            <TableCell>Delete</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {permissions.map((row, i) => (
                            <TableRow key={row?._id}>
                              <TableCell>{row.label}</TableCell>
                              <TableCell>
                                <Checkbox
                                  {...label}
                                  onChange={() =>
                                    onSelectChange(row, "addEdit")
                                  }
                                  checked={row?.isEdit || false}
                                />
                              </TableCell>
                              <TableCell>
                                <Checkbox
                                  {...label}
                                  onChange={() => onSelectChange(row, "isview")}
                                  checked={row?.isView || false}
                                />
                              </TableCell>
                              <TableCell>
                                <Checkbox
                                  {...label}
                                  onChange={() => onSelectChange(row, "isdel")}
                                  checked={row?.isDelete || false}
                                />
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </Grid>
                <div className="form_btn">
                  <Button
                    size="large"
                    type="submit"
                    className="btn btn_primary"
                    // onClick={() => setError(true)}
                  >
                    Save
                  </Button>
                </div>
              </CardContent>
            </form>
          </Card>
        </div>
      </MainContainer>
    </>
  );
};

export default AddSubAdmin;
